import React from 'react';
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle,
  AlertDialogDescription, AlertDialogFooter, AlertDialogAction, AlertDialogCancel,
} from './ui/alert-dialog';
import { AlertTriangle } from 'lucide-react';

// Reusable warning shown before exporting a BOM / Proposal when a margin is 0%.
export const MarginWarningDialog = ({ open, onCancel, onConfirm, materialsMargin, laborMargin, context = 'this document' }) => {
  const matZero = (Number(materialsMargin) || 0) === 0;
  const labZero = (Number(laborMargin) || 0) === 0;
  const which = matZero && labZero
    ? 'materials and labor margins are'
    : matZero ? 'materials margin is' : 'labor margin is';

  return (
    <AlertDialog open={open} onOpenChange={(v) => { if (!v) onCancel(); }}>
      <AlertDialogContent data-testid="margin-warning-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2 text-amber-600">
            <AlertTriangle className="w-5 h-5" /> Zero margin detected
          </AlertDialogTitle>
          <AlertDialogDescription>
            The <b>{which}</b> set to <b>0%</b>. Exporting {context} now will show costs with
            no markup applied. Do you want to continue exporting anyway?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel} data-testid="margin-warning-cancel">
            Go back &amp; set margin
          </AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="bg-amber-600 hover:bg-amber-700" data-testid="margin-warning-continue">
            Continue exporting
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default MarginWarningDialog;
